import { Chip } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import { useCatalog } from '../CatalogContext';
import LayerList from './LayerList';
import './SideBar.css';
import AddAssetButton from './AddAssetButton'
import DeleteAllButton from './DeleteAllButton'
// import LoadCatalogButton from '../Catalog/LoadCatalogButton'
//
const SideBar = ({ layerProps, setLayerProps }) => {

  const { catalog, setCatalog } = useCatalog();
  return (
    <div className='sidebar-container'>
      <div className="metadata">
        <div className='layer-buttons'>
          <AddAssetButton />
          <DeleteAllButton />
        </div>
        {catalog?.id ?
          <div style={{ 'whiteSpace': 'nowrap' }}> from
            <Tooltip title={catalog?.id}>
              <Chip label={catalog?.id} className='catalogChip' />
            </Tooltip>
          </div>
          : ''}
      </div>
      <LayerList layerProps={layerProps} setLayerProps={setLayerProps} />
      <div className='addAsset'>
        {/* <LoadCatalogButton/> */}
      </div>
    </div>
  );
}

export default SideBar;
